import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { FadeIn } from './FadeIn';
export function OfferSummary() {
  const mainItems = [{
    name: 'Sistema de Lectura en Orden Correcto™',
    price: '$29.999 ARS',
    isBonus: false
  }, {
    name: '200+ Actividades Imprimibles',
    price: 'Incluido',
    isBonus: false,
    isBadge: true
  }, {
    name: 'Guía Paso a Paso',
    price: 'Incluido',
    isBonus: false,
    isBadge: true
  }];
  const bonusItems = [{
    name: 'Cuaderno del Alfabeto Visual',
    price: '$6.999 ARS'
  }, {
    name: 'Rompecabezas del Alfabeto',
    price: '$8.999 ARS'
  }, {
    name: 'Cuaderno de Formación de Palabras',
    price: '$7.999 ARS'
  }, {
    name: 'Cuaderno de Trazado del Alfabeto',
    price: '$6.499 ARS'
  }, {
    name: 'Alfabeto Emocional',
    price: '$5.999 ARS'
  }, {
    name: 'Planner Semanal de Lectura',
    price: '$5.999 ARS'
  }, {
    name: 'Guía Antifrustración para Padres',
    price: '$8.999 ARS'
  }];
  return <section className="py-8 md:py-20 px-4 bg-transparent" data-id="element-236">
      <div className="max-w-3xl mx-auto" data-id="element-237">
        <FadeIn data-id="element-238">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-kid-yellow/30" data-id="element-239">
            <div className="overflow-hidden border-b border-gray-200" data-id="element-240">
              <img src="https://cdn.magicpatterns.com/uploads/amss8XA8X9Qmarc4J38DBE/20260307_1715_Image_Generation_simple_compose_01kk4yzbgweby8nda2gf500bht_(1).webp" alt="Sistema de Lectura en Orden Correcto - Paquete Completo" className="w-full h-auto" data-id="element-241" />
            </div>

            <div className="py-2.5 md:py-3 px-6 bg-kid-rose border-b border-kid-rose/80" data-id="element-242">
              <h3 className="text-white text-center font-semibold uppercase tracking-wider text-xs md:text-sm" data-id="element-243">
                TODO LO QUE RECIBÍS HOY
              </h3>
            </div>

            <div className="bg-white" data-id="element-244">
              {mainItems.map((item, idx) => <div key={idx} className="flex items-center justify-between px-4 md:px-8 py-3 md:py-4 border-b border-gray-100" data-id="element-245">
                  <div className="flex items-center gap-2.5 md:gap-3" data-id="element-246">
                    <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-kid-lime flex-shrink-0" data-id="element-247" />
                    <span className="text-gray-800 font-medium text-xs md:text-base" data-id="element-248">
                      {item.name}
                    </span>
                  </div>
                  {item.isBadge ? <span className="bg-kid-lime/10 border border-kid-lime/30 rounded-md px-2 py-0.5 md:px-2.5 md:py-1 text-[9px] md:text-xs font-semibold text-kid-lime uppercase tracking-wider" data-id="element-249">
                      {item.price}
                    </span> : <span className="text-gray-400 font-medium text-xs md:text-base line-through decoration-1" data-id="element-250">
                      {item.price}
                    </span>}
                </div>)}

              <div className="bg-accent-gold/20 h-0.5 mx-4 md:mx-6" data-id="element-251"></div>

              {bonusItems.map((item, idx) => <div key={idx} className="flex items-center justify-between px-4 md:px-8 py-2.5 md:py-3 border-b border-gray-100" data-id="element-252">
                  <div className="flex items-center gap-2.5 md:gap-3" data-id="element-253">
                    <span className="text-base md:text-lg" data-id="element-254">🎁</span>
                    <span className="text-gray-700 font-medium text-xs md:text-base" data-id="element-255">
                      Bono: {item.name}
                    </span>
                  </div>
                  <span className="text-gray-400 font-medium text-xs md:text-base line-through decoration-1" data-id="element-256">
                    {item.price}
                  </span>
                </div>)}
            </div>

            <div className="bg-gradient-to-b from-background-cream to-amber-50 p-6 md:p-14 text-center" data-id="element-257">
              <div className="text-accent-gold font-semibold text-xs uppercase tracking-wider mb-2" data-id="element-258">
                PRECIO DE OFERTA:
              </div>

              <div className="flex flex-col items-center justify-center mb-4 md:mb-6" data-id="element-259">
                <div className="text-gray-400 text-base md:text-xl font-medium line-through decoration-1 mb-0.5 md:mb-1" data-id="element-260">
                  $89.999 ARS
                </div>
                <div className="text-gray-900 text-3xl md:text-5xl font-bold" data-id="element-261">
                  $19.999{' '}
                  <span className="text-lg md:text-2xl font-semibold" data-id="element-262">ARS</span>
                </div>
              </div>

              <p className="text-gray-600 font-medium text-[11px] md:text-sm mb-4 md:mb-6 bg-white py-1.5 md:py-2 px-3 md:px-4 rounded-md inline-block border border-gray-200 shadow-sm" data-id="element-263">
                Pago único · Sin suscripciones · Sin cargos ocultos
              </p>

              <CTAButton text="AGREGAR AL CARRITO »" size="xl" className="w-full" animatePulse={true} data-id="element-264" />

              <p className="text-center text-gray-900 font-medium text-[11px] md:text-sm mt-3 md:mt-4 bg-kid-lime/20 py-1.5 px-3 md:px-4 rounded-md inline-block border border-kid-lime/30" data-id="element-265">
                Acceso inmediato al sistema completo
              </p>

              <div className="mt-5 md:mt-8" data-id="element-266">
                <img src="https://cdn.magicpatterns.com/uploads/2toouiPQVRL5wdaXRvt8mc/Captura_de_pantalla_2026-03-07_a_la(s)_08.46.16.png" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, Mercado Pago" className="mx-auto max-w-xs md:max-w-sm w-full" data-id="element-267" />
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}